import * as React from 'react'
import hex from 'assets/hex-light.svg'
import hexSimple from 'assets/hex-light-simple.svg'
import clsx from 'clsx'

const HexPattern = ({ simple, className, ...props }) => {
	const imgProps = simple
		? { src: hexSimple, width: 767, height: 402, }
		: { src: hex, width: 717, height: 424, }

	return (
		<img
			{...imgProps}
			className={clsx(className, 'pointer-events-none absolute md:max-w-[40vw]')}
			alt="" loading="lazy" draggable="false"
			{...props}
		/>
	)
}

export default HexPattern
